import { Redirect, Route, Switch } from 'react-router-dom';

import { getStartingRouteByProviderTypeName } from '~/lib/util/nav.util';

import AdminApp from './AdminApp';
import MaudApp from './MaudApp';
import OpsApp from './OpsApp';
import { Path } from './constants';
import useUserMode from './hooks/useUserMode';
import useSessionInit from './hooks/useSessionInit';
import { useGlobalContext } from '../lib/contexts/GlobalContext';
import { UserMode } from '../lib/contexts/ModeContext';
import Portal from '../pages/portal';
import useHelpWidget from '~/lib/hooks/useHelpWidget';
import StandaloneSurveyPage from '~/pages/standalone/surveys/[uuid]';

const AuthenticatedRoutes = () => {
  const { currentUser } = useGlobalContext();
  const { mode, permissions, shouldRenderPortal } = useUserMode();

  useSessionInit(currentUser);
  useHelpWidget();

  const maudRedirectRouteOnLogin = getStartingRouteByProviderTypeName(
    currentUser.providerTypeDetails?.name ?? '',
  );

  return (
    <Switch>
      <Route
        exact
        path={`${Path.MAUD_SURVEYS}/:uuid`}
        render={() =>
          permissions.maud ? (
            <StandaloneSurveyPage />
          ) : (
            <Redirect to={maudRedirectRouteOnLogin} />
          )
        }
      />

      {shouldRenderPortal ? (
        <>
          <Route component={Portal} exact path={Path.PORTAL} />
          <Redirect to={Path.PORTAL} />
        </>
      ) : (
        <>
          {permissions.admin && mode === UserMode.ADMIN && (
            <Route component={AdminApp} />
          )}
          {permissions.ops && mode === UserMode.OPS && (
            <Route component={OpsApp} />
          )}
          {permissions.maud && mode === UserMode.MAUD && (
            <Route component={MaudApp} />
          )}
        </>
      )}
    </Switch>
  );
};

export default AuthenticatedRoutes;
